<template>
  <f7-page name="activated-devices" ref="page">
    <f7-navbar :sliding="false" back-link="Back">
      <f7-nav-title sliding>{{ isDeactivations ? $t('DeActivatedDevices') : $t('ActivatedDevices') }} - {{ TimePeriodText }}</f7-nav-title>
      <f7-nav-right>
        <!--<f7-link icon-only icon="f7-icons icon-year" @click="calendarRange.open()"></f7-link>-->
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar position="top" class="toolbar-inner-no-padding">
      <f7-searchbar
          search-container=".vl-activated-devices"
          search-item="li"
          search-in=".item-title"

      ></f7-searchbar>
    </f7-toolbar>
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>
    <div class="searchbar-backdrop"></div>

    <f7-list class="searchbar-not-found">
      <f7-list-item :title="$t('NothingFound')"></f7-list-item>
    </f7-list>

    <f7-block v-if="!isLoading && isNoData">
      <p>{{ $t('NoRecordsFound') }}</p>
    </f7-block>

    <!--<input type="text" placeholder="Select date range" readonly="readonly" id="calendar-range" class="display-none"  />-->

    <f7-list v-if="isLoading && isNoData" media-list class="skeleton-text skeleton-effect-wave no-margin-top" >
      <f7-list-item
          v-for="n in 4"
          :key="n"
          title="Title"
          header="Header"
          after="after text"
          text="some very long text will go here"
      >
      </f7-list-item>
    </f7-list>

    <f7-list
        ref="vl"
        class="vl vl-activated-devices no-margin-top bigger-item-text"
        virtual-list
        media-list
        no-hairlines
        :virtual-list-params="{ items, searchAll, renderExternal, height: heightCalc }"
    >
      <ul>
        <f7-list-item
            v-for="(item, index) in vlData.items"
            link="#"
            :key="`key-activated-devices-${ index }`"
            :title="item.ACTIVE_IMEI"
            :header="item.AGENT_NAME ? item.AGENT_NAME : $t('na')"
            :style="`top: ${vlData.topPosition}px`"
            @click="showAssetMenu(item.ACTIVE_IMEI)"
        >
          <template #after>
            {{ dateFormat(item.ASSET_ACTIVAION_TIME+'+0000', 'datetime') }}
          </template>
          <template #text>
            <div >{{ $t('CustomerName') }}: <b>{{ item.CLIENT_NAME ? item.CLIENT_NAME : $t('na') }}</b></div>
            <div >{{ $t('SolutionType') }}: <b>{{ item.ASSET_SOLUTION ? item.ASSET_SOLUTION : $t('na') }}</b></div>
            <div >{{ $t('ServicePlan') }}: <b>{{ item.ASSET_SERVICE_PLAN_NAME ? item.ASSET_SERVICE_PLAN_NAME : $t('na') }}</b></div>
            <div >{{ $t('Action') }}: <b>{{ item.ASSET_ACTION ? item.ASSET_ACTION : $t('na') }}</b></div>
            <div >{{ $t('PaymentType') }}: <b>{{ item.ASSET_PAYMENT_WAY ? item.ASSET_PAYMENT_WAY : $t('na') }}</b></div>
          </template>

        </f7-list-item>
      </ul>
    </f7-list>

    <asset-menu
        v-model:isOpened = isAssetMenuOpened
        :assetData = "selectedAssetData"
    />

  </f7-page>
</template>

<script>
import {QTAPI} from "../../services/qt-api";
import {mapGetters} from "vuex";
import {f7, theme} from "framework7-vue";
import moment from "moment-mini";
import {dateFormat} from "../../js/helpers";

import AssetMenu from '../assets/components/asset-menu'

export default {
  name: "activated-devices",

  components:{
    AssetMenu
  },

  props: {
    f7router: Object,
    f7route: Object,
  },

  data(){
    return {
      period: this.f7route.query.period,
      isDeactivations: this.f7route.query.type === 'deactivation',
      isLoading: false,
      isNoData: true,

      items: [],
      vlData: {
        items: [],
      },
      vl: null,
      selectedAssetData: {},
      isAssetMenuOpened: false,
      calendarRange: null,
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'UserInfoPreEdit']),
    TimePeriodText(){
      let texts = {
        'day': this.$t('Today'),
        'week': this.$t('ThisWeek'),
        'month': this.$t('ThisMonth'),
      }
      return texts[this.period]
    }
  },

  mounted() {
    this.vl = f7.virtualList.get(this.$refs.vl.$el);
    //this.initCalendar()
    if(this.period){
      this.getActivationsList(this.period, this.isDeactivations)
    }


  },

  unmounted(){
    if(this.calendarRange) this.calendarRange.destroy()

  },

  methods: {
    /*initCalendar(){
      this.calendarRange = f7.calendar.create({
        inputEl: '#calendar-range',
        rangePicker: true,
        backdrop: true,
        openIn: 'customModal',
      });
    },*/
    async getActivationsList(period = 'day', deactivations = false){
      let solutionsStr = deactivations
          ? 'DeActivate'
          : this.UserInfoPreEdit.Solutions.filter(itm => itm.Value.toLowerCase() !== 'nonactivated' && itm.Value.toLowerCase() !== 'deactivate').map(itm=>itm.Value).toString()

      let from = moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      switch (period){
        case "week":
          from = moment.utc().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
          break
        case "month":
          from = moment.utc().startOf('month').format('YYYY-MM-DD HH:mm:ss')
          break
      }

      this.isLoading = true
      let result = await QTAPI.GetActivationHistory({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        From: from,
        To: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
        SolutionCodes: solutionsStr || ''
      })
      this.isLoading = false
      this.isNoData = !result || !result.length
      if(!result) return

      result.sort((a,b) => moment(b.ASSET_ACTIVAION_TIME).valueOf() - moment(a.ASSET_ACTIVAION_TIME).valueOf())
      this.items = result
      this.vl.replaceAllItems(result);
      console.log(result)

    },
    searchAll(query, items) {
      const found = [];
      if(query) query = query.trim().toLowerCase()
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].ACTIVE_IMEI.toLowerCase().indexOf(query) >= 0 ||
            items[i].AGENT_NAME.toLowerCase().indexOf(query) >= 0 ||
            items[i].CLIENT_NAME.toLowerCase().indexOf(query) >= 0 ||
            query === '')
          found.push(i);
      }
      return found; // return array with mathced indexes
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    heightCalc(){
      return theme.ios ? 162 : 166;
    },
    dateFormat(...options){
      return dateFormat(...options)
    },
    async showAssetMenu(imei){
      this.isLoading = true
      let result = await QTAPI.GetAssetList({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        page: 1,
        rows: 5,
        sort: 'Name',
        order: 'asc',

        q: imei,
      });
      this.isLoading = false

      if(!result?.rows?.length){
        f7.dialog.alert(this.$t('NoAssetFound'), this.$t('Error'))
        return
      }

      this.selectedAssetData = result.rows[0]
      this.isAssetMenuOpened = true
    }
    /*async exportToExcel(rawRows){
      if (!rawRows?.length) return

      let rows = []
      let captions = [
        this.$t('IMEI'),
        this.$t('AssetName'),
        this.$t('AssetType'),
        this.$t('SolutionType'),
        this.$t('ServicePlan'),
        this.$t('ActivationDate'),
        this.$t('FirstName'),
        this.$t('LastName'),
        this.$t('Email'),
        this.$t('Mobile'),
      ]
      rawRows.forEach(itm => {
        rows.push([
          itm.IMEI ? itm.IMEI.trim() : this.$t('na'),
          itm.AssetName ? itm.AssetName : this.$t('na'),
          itm.AssetType || this.$t('na'),
          itm.Solution || this.$t('na'),
          itm.ServiceProfile || this.$t('na'),
          itm.ActivationDate || this.$t('na'),
          itm.FirstName || this.$t('na'),
          itm.SubName || this.$t('na'),
          itm.Email || this.$t('na'),
          itm.Mobile || this.$t('na'),
        ])
      })

      //need to setup plugin
    },*/
  }
}
</script>
